/**
 * Merged items column: lead product image, optional extra-item count, and reserve indicator.
 */
import { observer } from "mobx-react";
import AHref from "../../../../../components/ahref/ahref";
import FontBody2 from "../../../../../components/fonts/font-body2/font-body2";
import { FONT_COLOR } from "../../../../../components/fonts/font-props";
import useDashboardTranslation from "../../../../../dashboard-translation/hooks/dashboard-translation-hook";
import placeholderImage from "../../../../../images/info-icon.svg";
import RmaListItemStore from "../../../rma-list-page/stores/rma-item-store";
import ReserveItemsIndicator from "./reserve-items-indicator/reserve-items-indicator";
import "./table-column-items.scss";

export interface ITableColumnItemsProps {
    rma: RmaListItemStore;
}

const TableColumnItems: React.FC<ITableColumnItemsProps> = observer(({ rma }) => {
    const scope = "dashboard-returns-page";
    const { getTranslation } = useDashboardTranslation();
    const imagesUrls = rma.imagesUrls;
    const leadImg = imagesUrls.length > 0 ? imagesUrls[0] : placeholderImage;
    const extraCount = rma.amount > 1 ? rma.amount - 1 : 0;
    const moreLabel = extraCount > 0 ? getTranslation("RMA_LIST_ITEMS_MORE", scope, [String(extraCount)]) : "";
    return (
        <div className="table-column-items" onClick={(e) => e.stopPropagation()}>
            {rma.reservedItemsInfo && <ReserveItemsIndicator reserveItemsInfo={rma.reservedItemsInfo} />}
            <div className="table-column-items__media">
                <AHref href={leadImg} target="_blank">
                    <img src={leadImg} alt="" />
                </AHref>
                {extraCount > 0 && <FontBody2 color={FONT_COLOR.PRIMARY3_50}>{moreLabel}</FontBody2>}
            </div>
        </div>
    );
});

export default TableColumnItems;
